export default "__VITE_ASSET__CPNG5ezK__"